import * as React from "react";
const ToolIcon = ({
  size = 16,
  title = "ToolIcon",
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: size, height: size, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: "pds-icon", title, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9.8 4.2a.667.667 0 0 0 0 .933L10.867 6.2a.667.667 0 0 0 .933 0l2.513-2.513A4 4 0 0 1 9.02 8.98l-4.607 4.607a1.414 1.414 0 0 1-2-2L7.02 6.98a4 4 0 0 1 5.293-5.293L9.807 4.193 9.8 4.2Z", stroke: "currentColor", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }));
export default ToolIcon;
